module.exports = __webpack_public_path__ + "static/media/graphic.fd9fe8b2.jpg";